// // src/pages/treatments/KneeReplacementPage.jsx
// import React from "react";
// import TreatmentTemplate from "./TreatmentTemplate";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

// const KNEE_REPLACEMENT_TREATMENT = {
//   slug: "knee-replacement",
//   name: "Knee Replacement Surgery",
//   shortName: "Knee Replacement",
//   tagline: "Walk Pain-Free Again. Precision Surgery. Lasting Results.",
//   heroSubtag:
//     "Advanced knee replacement surgery at a fraction of Western costs. India's top orthopaedic surgeons. Exceptional outcomes.",
//   description:
//     "Comprehensive knee replacement care covering total knee replacement, partial (unicompartmental) knee replacement, robotic-assisted surgery and revision knee replacement — supported by advanced physiotherapy, pain management and lifelong post-operative follow-up. Our multidisciplinary orthopaedic teams review every case to deliver globally benchmarked, personalised treatment plans with outstanding functional outcomes.",
//   heroImage: "/KneeReplacement.jpeg",
//   category: "Orthopedics ",
//   badge: "Advanced Joint Care",
//   accentColor: "blue",
//   costCard: {
//     label: "Knee replacement packages",
//     value: "₹2.5L–₹5L",
//     compare: "vs. £15,000–£25,000 in the UK",
//     stay: "Typically 10–14 days in India post-surgery",
//     stayCompare: "vs. $30,000–$60,000 in the USA",
//   },
//   stats: [
//     { label: "Success Rate", value: "97%+", icon: Award },
//     { label: "Surgeries Performed", value: "30,000+", icon: Users },
//     { label: "Years Experience", value: "25+", icon: Shield },
//     { label: "Hospital Stay", value: "5–7 Days", icon: Clock },
//   ],
//   benefits: [
//     "Robotic-assisted total knee replacement for millimetre-precise implant positioning",
//     "Minimally invasive surgical techniques — smaller incisions, faster recovery",
//     "Patient-specific implants manufactured from pre-operative CT scan data",
//     "Bilateral (both knees) simultaneous replacement where clinically appropriate",
//     "Unicompartmental (partial) knee replacement for early-stage disease",
//     "Revision knee replacement for failed previous implants",
//     "Accelerated rehabilitation — walking within 24 hours of surgery",
//     "Comprehensive pain management — multimodal anaesthesia, nerve blocks",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Assessment & Planning",
//       desc: "Full orthopaedic evaluation — weight-bearing X-rays, MRI, deformity analysis and implant selection with 3D pre-operative planning.",
//       duration: "2–3 Days",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Pre-Operative Optimisation",
//       desc: "Cardiac and anaesthesia clearance, physiotherapy assessment, blood optimisation and patient education on post-operative recovery.",
//       duration: "1–2 Days",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Knee Replacement Surgery",
//       desc: "Robotic-assisted or conventional total/partial knee replacement under spinal or general anaesthesia by senior orthopaedic surgeon.",
//       duration: "1.5–2.5 Hours",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Rehabilitation & Discharge",
//       desc: "Physiotherapy begins day 1 post-surgery. Stair climbing by day 3. Discharge at day 5–7 with home exercise programme and follow-up protocol.",
//       duration: "5–7 Days",
//       icon: Heart,
//     },
//   ],
//   faqs: [
//     {
//       q: "Who needs knee replacement surgery?",
//       a: "Knee replacement is recommended for patients with severe knee arthritis (osteoarthritis, rheumatoid arthritis or post-traumatic arthritis) causing persistent pain, stiffness and loss of function that has not responded to conservative treatment — physiotherapy, injections and anti-inflammatory medications.",
//     },
//     {
//       q: "What is robotic-assisted knee replacement?",
//       a: "Robotic-assisted knee replacement uses a CT-based 3D model of your knee to plan the exact position, size and alignment of your implant before surgery. During the procedure, the robotic arm guides the surgeon to execute cuts within 1mm of the pre-operative plan — resulting in better alignment, less bone removal and faster recovery.",
//     },
//     {
//       q: "How long does a knee replacement last?",
//       a: "Modern knee implants last 20–25 years in the majority of patients. Longevity depends on activity level, weight, implant type and surgical technique. Robotic-assisted surgery improves alignment accuracy, which is one of the most important factors for long-term implant survival.",
//     },
//     {
//       q: "How soon can I walk after knee replacement?",
//       a: "Most patients stand and take their first steps with a physiotherapist 4–6 hours after surgery. By day 2–3, patients walk independently with a frame. By day 5–7, most can manage stairs. Full functional recovery — walking without aids — typically takes 6–8 weeks.",
//     },
//     {
//       q: "How long will I need to stay in India?",
//       a: "Most international patients stay 10–14 days in India — 5–7 days in hospital followed by 5–7 days of supervised physiotherapy at a nearby recovery facility. PaxGrow arranges serviced accommodation and daily physiotherapy sessions before you fly home. You should be fit to fly economy class within 12–14 days of surgery.",
//     },
//     {
//       q: "What is the cost of knee replacement in India vs. the UK or USA?",
//       a: "A complete knee replacement package in India (including implant, surgery, hospital stay, physiotherapy and follow-up) typically costs ₹2.5L–₹5L ($3,000–$6,500), compared to £15,000–£25,000 in the UK and $30,000–$60,000 in the USA — with equivalent implant brands (Zimmer Biomet, Stryker, DePuy) and superior surgeon experience volumes.",
//     },
//     {
//       q: "Can both knees be replaced at the same time?",
//       a: "Yes. Simultaneous bilateral knee replacement is offered to medically fit patients under 70 at high-volume Indian centres. It reduces total hospitalisation, rehabilitation and travel time significantly. Your surgeon will advise based on your cardiac fitness, BMI and bone quality.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. Ashok Rajgopal",
//       specialty: "Knee Replacement & Robotic Orthopaedics",
//       experience: "35 Years",
//       rating: 4.9,
//       reviews: 4200,
//       image: "https://randomuser.me/api/portraits/men/54.jpg",
//       qualifications: "MBBS, MS (Ortho), MCh, FRCS (Edinburgh)",
//       hospital: "Medanta — The Medicity, Gurgaon",
//     },
//     {
//       name: "Dr. Vijay Bose",
//       specialty: "Joint Replacement & Revision Surgery",
//       experience: "28 Years",
//       rating: 4.9,
//       reviews: 3100,
//       image: "https://randomuser.me/api/portraits/men/66.jpg",
//       qualifications: "MBBS, DNB (Ortho), FRCS, Fellowship (USA)",
//       hospital: "Apollo Hospitals, Chennai",
//     },
//     {
//       name: "Dr. Sanjay Agarwala",
//       specialty: "Hip & Knee Replacement",
//       experience: "30 Years",
//       rating: 4.8,
//       reviews: 2700,
//       image: "https://randomuser.me/api/portraits/men/48.jpg",
//       qualifications: "MBBS, MS (Ortho), DNB, FICS",
//       hospital: "Hinduja Hospital, Mumbai",
//     },
//   ],
//   testimonials: [
//     {
//       name: "Joseph Kamau",
//       age: 64,
//       location: "Nairobi, Kenya",
//       text: "I had been unable to walk more than 100 metres for three years. The robotic knee replacement at Apollo Chennai gave me my life back. Two months later I walked 5 kilometres without stopping. The cost was one-fifth of what a private hospital in Nairobi quoted me.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/82.jpg",
//       treatment: "Robotic Total Knee Replacement — Bilateral",
//       date: "February 2024",
//     },
//     {
//       name: "Maryam Al-Blooshi",
//       age: 58,
//       location: "Abu Dhabi, UAE",
//       text: "Severe rheumatoid arthritis had destroyed both my knees. The team at Medanta did both knees in one surgery. The physiotherapy started the very next morning. I flew home after 12 days walking with just one stick. Truly miraculous.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/61.jpg",
//       treatment: "Bilateral Total Knee Replacement — Rheumatoid Arthritis",
//       date: "March 2024",
//     },
//     {
//       name: "Peter Mensah",
//       age: 71,
//       location: "Accra, Ghana",
//       text: "My previous knee replacement done in Accra had failed after 8 years. I needed a complex revision surgery. PaxGrow found me a specialist revision surgeon in Mumbai. The revision was successful and I am now pain-free for the first time in years.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/69.jpg",
//       treatment: "Revision Total Knee Replacement",
//       date: "April 2024",
//     },
//   ],
// };

// const KNEE_REPLACEMENT_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why African & Gulf Patients Choose India for Knee Replacement",
//   whyIndiaReasons: [
//     "NABH-accredited orthopaedic centres with Mako robotic systems, patient-specific implants and same-day physiotherapy protocols",
//     "Senior orthopaedic surgeons performing 500–1,000 knee replacements per year — ten times the volume of most Western surgeons",
//     "Surgery confirmed within 5–7 days of arrival — no 12–18 month NHS waiting lists",
//     "Apollo, Medanta, Fortis, Max, Hinduja — globally ranked joint replacement programmes with published outcome data",
//   ],
//   conditionsTitle: "Knee Conditions We Facilitate Treatment For",
//   conditions: [
//     "Severe Osteoarthritis of the Knee",
//     "Rheumatoid Arthritis",
//     "Post-Traumatic Knee Arthritis",
//     "Avascular Necrosis of the Knee",
//     "Failed Previous Knee Replacement",
//     "Severe Knee Deformity (Varus/Valgus)",
//     "Psoriatic Arthritis",
//     "Ankylosing Spondylitis (Knee)",
//     "Osteonecrosis of the Femoral Condyle",
//     "Ligament Damage with Arthritis",
//     "Knee Stiffness Post-Injury",
//     "Gout-Related Joint Destruction",
//   ],
//   stayValue:
//     "10–14 days total: 5–7 days hospital stay followed by 5–7 days supervised physiotherapy before flying home",
//   costTitle: "Why India for Knee Replacement Surgery?",
//   costRows: [
//     {
//       procedure: "Total Knee Replacement (single knee)",
//       india: "₹2.5L–₹4.0L",
//       africa: "$8,000–$15,000",
//       ukusa: "$30,000–$50,000",
//     },
//     {
//       procedure: "Robotic-Assisted Total Knee Replacement",
//       india: "₹3.5L–₹5.5L",
//       africa: "Largely unavailable",
//       ukusa: "$40,000–$65,000",
//     },
//     {
//       procedure: "Bilateral Knee Replacement (both knees)",
//       india: "₹4.5L–₹8.0L",
//       africa: "$15,000–$25,000",
//       ukusa: "$55,000–$90,000",
//     },
//     {
//       procedure: "Unicompartmental (Partial) Knee Replacement",
//       india: "₹2.0L–₹3.5L",
//       africa: "$6,000–$12,000",
//       ukusa: "$20,000–$40,000",
//     },
//     {
//       procedure: "Revision Knee Replacement",
//       india: "₹4.0L–₹7.0L",
//       africa: "Largely unavailable",
//       ukusa: "$50,000–$90,000",
//     },
//   ],
// };

// const KneeReplacementPage = () => {
//   return (
//     <TreatmentTemplate
//       treatment={KNEE_REPLACEMENT_TREATMENT}
//       paxgrowData={KNEE_REPLACEMENT_PAXGROW}
//     />
//   );
// };

// export default KneeReplacementPage;

// src/pages/treatments/KneeReplacementPage.jsx
import React from "react";
import TreatmentTemplate from "./TreatmentTemplate";
import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

const KNEE_REPLACEMENT_TREATMENT = {
  slug: "knee-replacement",
  name: "Knee Replacement Surgery",
  shortName: "Knee Replacement",
  tagline: "Walk Pain-Free Again. Precision Surgery. Lasting Results.",
  heroSubtag:
    "Advanced knee replacement surgery at a fraction of Western costs. India's top orthopaedic surgeons. Exceptional outcomes.",
  description:
    "Comprehensive knee replacement care covering total knee replacement, partial (unicompartmental) knee replacement, robotic-assisted surgery and revision knee replacement — supported by advanced physiotherapy, pain management and lifelong post-operative follow-up. Our multidisciplinary orthopaedic teams review every case to deliver globally benchmarked, personalised treatment plans with outstanding functional outcomes.",
  heroImage: "/KneeReplacement.jpeg",
  category: "Orthopedics ",
  badge: "Advanced Joint Care",
  accentColor: "blue",
  costCard: {
    label: "Knee replacement packages",
    value: "$3,000–$6,000",
    compare: "vs. $18,000–$30,000 in the UK",
    stay: "Typically 10–14 days in India post-surgery",
    stayCompare: "vs. $30,000–$60,000 in the USA",
  },
  stats: [
    { label: "Success Rate", value: "97%+", icon: Award },
    { label: "Surgeries Performed", value: "30,000+", icon: Users },
    { label: "Years Experience", value: "25+", icon: Shield },
    { label: "Hospital Stay", value: "5–7 Days", icon: Clock },
  ],
  benefits: [
    "Robotic-assisted total knee replacement for millimetre-precise implant positioning",
    "Minimally invasive surgical techniques — smaller incisions, faster recovery",
    "Patient-specific implants manufactured from pre-operative CT scan data",
    "Bilateral (both knees) simultaneous replacement where clinically appropriate",
    "Unicompartmental (partial) knee replacement for early-stage disease",
    "Revision knee replacement for failed previous implants",
    "Accelerated rehabilitation — walking within 24 hours of surgery",
    "Comprehensive pain management — multimodal anaesthesia, nerve blocks",
  ],
  procedure: [
    {
      step: "01",
      title: "Assessment & Planning",
      desc: "Full orthopaedic evaluation — weight-bearing X-rays, MRI, deformity analysis and implant selection with 3D pre-operative planning.",
      duration: "2–3 Days",
      icon: Calendar,
    },
    {
      step: "02",
      title: "Pre-Operative Optimisation",
      desc: "Cardiac and anaesthesia clearance, physiotherapy assessment, blood optimisation and patient education on post-operative recovery.",
      duration: "1–2 Days",
      icon: Activity,
    },
    {
      step: "03",
      title: "Knee Replacement Surgery",
      desc: "Robotic-assisted or conventional total/partial knee replacement under spinal or general anaesthesia by senior orthopaedic surgeon.",
      duration: "1.5–2.5 Hours",
      icon: ThumbsUp,
    },
    {
      step: "04",
      title: "Rehabilitation & Discharge",
      desc: "Physiotherapy begins day 1 post-surgery. Stair climbing by day 3. Discharge at day 5–7 with home exercise programme and follow-up protocol.",
      duration: "5–7 Days",
      icon: Heart,
    },
  ],
  faqs: [
    {
      q: "Who needs knee replacement surgery?",
      a: "Knee replacement is recommended for patients with severe knee arthritis (osteoarthritis, rheumatoid arthritis or post-traumatic arthritis) causing persistent pain, stiffness and loss of function that has not responded to conservative treatment — physiotherapy, injections and anti-inflammatory medications.",
    },
    {
      q: "What is robotic-assisted knee replacement?",
      a: "Robotic-assisted knee replacement uses a CT-based 3D model of your knee to plan the exact position, size and alignment of your implant before surgery. During the procedure, the robotic arm guides the surgeon to execute cuts within 1mm of the pre-operative plan — resulting in better alignment, less bone removal and faster recovery.",
    },
    {
      q: "How long does a knee replacement last?",
      a: "Modern knee implants last 20–25 years in the majority of patients. Longevity depends on activity level, weight, implant type and surgical technique. Robotic-assisted surgery improves alignment accuracy, which is one of the most important factors for long-term implant survival.",
    },
    {
      q: "How soon can I walk after knee replacement?",
      a: "Most patients stand and take their first steps with a physiotherapist 4–6 hours after surgery. By day 2–3, patients walk independently with a frame. By day 5–7, most can manage stairs. Full functional recovery — walking without aids — typically takes 6–8 weeks.",
    },
    {
      q: "How long will I need to stay in India?",
      a: "Most international patients stay 10–14 days in India — 5–7 days in hospital followed by 5–7 days of supervised physiotherapy at a nearby recovery facility. PaxGrow arranges serviced accommodation and daily physiotherapy sessions before you fly home. You should be fit to fly economy class within 12–14 days of surgery.",
    },
    {
      q: "What is the cost of knee replacement in India vs. the UK or USA?",
      a: "A complete knee replacement package in India (including implant, surgery, hospital stay, physiotherapy and follow-up) typically costs $3,000–$6,500, compared to $18,000–$30,000 in the UK and $30,000–$60,000 in the USA — with equivalent implant brands (Zimmer Biomet, Stryker, DePuy) and superior surgeon experience volumes.",
    },
    {
      q: "Can both knees be replaced at the same time?",
      a: "Yes. Simultaneous bilateral knee replacement is offered to medically fit patients under 70 at high-volume Indian centres. It reduces total hospitalisation, rehabilitation and travel time significantly. Your surgeon will advise based on your cardiac fitness, BMI and bone quality.",
    },
  ],
  doctors: [
    {
      name: "Dr. Ashok Rajgopal",
      specialty: "Knee Replacement & Robotic Orthopaedics",
      experience: "35 Years",
      rating: 4.9,
      reviews: 4200,
      image: "https://randomuser.me/api/portraits/men/54.jpg",
      qualifications: "MBBS, MS (Ortho), MCh, FRCS (Edinburgh)",
      hospital: "Medanta — The Medicity, Gurgaon",
    },
    {
      name: "Dr. Vijay Bose",
      specialty: "Joint Replacement & Revision Surgery",
      experience: "28 Years",
      rating: 4.9,
      reviews: 3100,
      image: "https://randomuser.me/api/portraits/men/66.jpg",
      qualifications: "MBBS, DNB (Ortho), FRCS, Fellowship (USA)",
      hospital: "Apollo Hospitals, Chennai",
    },
    {
      name: "Dr. Sanjay Agarwala",
      specialty: "Hip & Knee Replacement",
      experience: "30 Years",
      rating: 4.8,
      reviews: 2700,
      image: "https://randomuser.me/api/portraits/men/48.jpg",
      qualifications: "MBBS, MS (Ortho), DNB, FICS",
      hospital: "Hinduja Hospital, Mumbai",
    },
  ],
  testimonials: [
    {
      name: "Joseph Kamau",
      age: 64,
      location: "Nairobi, Kenya",
      text: "I had been unable to walk more than 100 metres for three years. The robotic knee replacement at Apollo Chennai gave me my life back. Two months later I walked 5 kilometres without stopping. The cost was one-fifth of what a private hospital in Nairobi quoted me.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/82.jpg",
      treatment: "Robotic Total Knee Replacement — Bilateral",
      date: "February 2024",
    },
    {
      name: "Maryam Al-Blooshi",
      age: 58,
      location: "Abu Dhabi, UAE",
      text: "Severe rheumatoid arthritis had destroyed both my knees. The team at Medanta did both knees in one surgery. The physiotherapy started the very next morning. I flew home after 12 days walking with just one stick. Truly miraculous.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/61.jpg",
      treatment: "Bilateral Total Knee Replacement — Rheumatoid Arthritis",
      date: "March 2024",
    },
    {
      name: "Peter Mensah",
      age: 71,
      location: "Accra, Ghana",
      text: "My previous knee replacement done in Accra had failed after 8 years. I needed a complex revision surgery. PaxGrow found me a specialist revision surgeon in Mumbai. The revision was successful and I am now pain-free for the first time in years.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/69.jpg",
      treatment: "Revision Total Knee Replacement",
      date: "April 2024",
    },
  ],
};

const KNEE_REPLACEMENT_PAXGROW = {
  whyIndiaSubtitle: "WHY PAXGROW + INDIA",
  whyIndiaTitle: "Why African & Gulf Patients Choose India for Knee Replacement",
  whyIndiaReasons: [
    "NABH-accredited orthopaedic centres with Mako robotic systems, patient-specific implants and same-day physiotherapy protocols",
    "Senior orthopaedic surgeons performing 500–1,000 knee replacements per year — ten times the volume of most Western surgeons",
    "Surgery confirmed within 5–7 days of arrival — no 12–18 month NHS waiting lists",
    "Apollo, Medanta, Fortis, Max, Hinduja — globally ranked joint replacement programmes with published outcome data",
  ],
  conditionsTitle: "Knee Conditions We Facilitate Treatment For",
  conditions: [
    "Severe Osteoarthritis of the Knee",
    "Rheumatoid Arthritis",
    "Post-Traumatic Knee Arthritis",
    "Avascular Necrosis of the Knee",
    "Failed Previous Knee Replacement",
    "Severe Knee Deformity (Varus/Valgus)",
    "Psoriatic Arthritis",
    "Ankylosing Spondylitis (Knee)",
    "Osteonecrosis of the Femoral Condyle",
    "Ligament Damage with Arthritis",
    "Knee Stiffness Post-Injury",
    "Gout-Related Joint Destruction",
  ],
  stayValue:
    "10–14 days total: 5–7 days hospital stay followed by 5–7 days supervised physiotherapy before flying home",
  costTitle: "Why India for Knee Replacement Surgery?",
  costRows: [
    {
      procedure: "Total Knee Replacement (single knee)",
      india: "$3,000–$4,800",
      africa: "$8,000–$15,000",
      ukusa: "$30,000–$50,000",
    },
    {
      procedure: "Robotic-Assisted Total Knee Replacement",
      india: "$4,200–$6,600",
      africa: "Largely unavailable",
      ukusa: "$40,000–$65,000",
    },
    {
      procedure: "Bilateral Knee Replacement (both knees)",
      india: "$5,400–$9,600",
      africa: "$15,000–$25,000",
      ukusa: "$55,000–$90,000",
    },
    {
      procedure: "Unicompartmental (Partial) Knee Replacement",
      india: "$2,400–$4,200",
      africa: "$6,000–$12,000",
      ukusa: "$20,000–$40,000",
    },
    {
      procedure: "Revision Knee Replacement",
      india: "$4,800–$8,400",
      africa: "Largely unavailable",
      ukusa: "$50,000–$90,000",
    },
  ],
};

const KneeReplacementPage = () => {
  return (
    <TreatmentTemplate
      treatment={KNEE_REPLACEMENT_TREATMENT}
      paxgrowData={KNEE_REPLACEMENT_PAXGROW}
    />
  );
};

export default KneeReplacementPage;